<script lang="ts">
import DataLayer from '~/extensions/DataLayer'

export default {
    mounted() {
        const urlPage = window.location
        window.addEventListener('load', () => {
            DataLayer.push({
                event: 'chatbot_impression',
                partner: 'oral b',
                type: 'impression',
                url: urlPage,
            })
        })

        document.onclick = function (event) {
            const el = event.target as HTMLElement
            if (el?.className === 'quriobotWidgetPopup--button') {
                DataLayer.push({
                    event: 'chatbot_click',
                    partner: 'oral b',
                    type: 'click',
                    url: urlPage,
                })
            }

            if (el?.className === 'large--button') {
                DataLayer.push({
                    event: 'chatbot_redirect',
                    partner: 'oral b',
                    type: 'redirect',
                    url: urlPage,
                })
            }
        }
    },
}
</script>

<style>
#zdbutton {
    display: none !important;
}
#amiobutton {
    display: none !important;
}
</style>
